function SiteHeaderController($scope, $element, $window, $timeout, authService) {
    $scope.isDesktop = $window.innerWidth >= 992;
    $scope.navItems = null;

    this.$postLink = function() {
        var navItems = [];
        // Get the nav list
        var $ul = $('.navigation ul', $element);
        // Loop through the items
        $('li', $ul).each(function() {
            // Get the A element
            var $a = $('a', $(this)).first();
            if ($a.length <= 0) return;
            // Add to collection
            navItems.push({
                className: $(this)[0].className,
                label: $a[0].text,
                href: $a[0].href
            });
        });
        $scope.navItems = navItems;
    };

    $window.addEventListener('resize', function() {
        $timeout(function() { $scope.isDesktop = $window.innerWidth >= 992; });
    });
}

function SiteMobileHeaderController($rootScope, $scope, authService) {
    this.$onInit = function() {
        $scope.navItems = this.navItems;
    };

    $scope.handleMenuClick = function(e) {
        e.preventDefault();
        $scope.menuOpen = !$scope.menuOpen;
    };
    $scope.handleMenuOffClick = function(e) {
        $scope.menuOpen = false;
        if (e.target.localName === 'a') return;
        e.preventDefault();
    };
    $scope.handleLogout = function(e) {
        e.preventDefault();
        authService.logout()
            .then(function() { window.location.href = '/'; });
    };

    var updateAuth = function() {
        if (!authService.accessToken) {
            $scope.auth = null;
            return;
        }
        $scope.auth = {
            isAdmin: authService.claims.admin,
            accessToken: authService.accessToken
        };
        var firstName = authService.claims['firstName'];
        var lastName = authService.claims['lastName'];
        if (firstName && lastName) {
            $scope.auth.initials = firstName[0].toUpperCase() + lastName[0].toUpperCase();
            $scope.auth.name = firstName;
        }
        else {
            $scope.auth.name = authService.claims['name'];
            $scope.auth.initials = $scope.auth.name[0].toUpperCase();
        }
    };
    updateAuth();

    $rootScope.$on('auth.login', updateAuth);
    $rootScope.$on('auth.logout', updateAuth);
}
function SiteDesktopHeaderController($rootScope, $scope, authService) {
    $scope.isExMenuOpen = false;

    var updateAuth = function() {
        if (!authService.accessToken) {
            $scope.auth = null;
            return;
        }
        $scope.auth = {
            isAdmin: authService.claims.admin,
            accessToken: authService.accessToken
        };
        var firstName = authService.claims['firstName'];
        var lastName = authService.claims['lastName'];
        if (firstName && lastName) {
            $scope.auth.initials = firstName[0].toUpperCase() + lastName[0].toUpperCase();
            $scope.auth.name = firstName;
        }
        else {
            $scope.auth.name = authService.claims['name'];
            $scope.auth.initials = $scope.auth.name[0].toUpperCase();
        }
    };
    updateAuth();

    var mouseDown = function(e) {
        if (!$scope.isExMenuOpen) return;
        if (!e.target.classList.contains('ex-menu-a')) {
            e.preventDefault();
            $scope.$apply(function() {
                $scope.isExMenuOpen = false;
            });
            return;
        }
        setTimeout(function() {
            $scope.isExMenuOpen = false;
            $scope.$apply();
        }, 500);
    }

    this.$onInit = function() {
        $scope.navItems = this.navItems;
        window.addEventListener('mousedown', mouseDown);
    };
    this.$onDestroy = function() {
        window.removeEventListener('mousedown', mouseDown);
    }

    $scope.handleLogout = function(e) {
        e.preventDefault();
        authService.logout();
    };


    $rootScope.$on('auth.login', updateAuth);
    $rootScope.$on('auth.logout', updateAuth);



    $scope.exMenuClick = function() {
        console.log('exMenuClick');
        $scope.isExMenuOpen = !$scope.isExMenuOpen;
    }
}

angular.module('app')
    .component('siteHeader', {
        transclude: true,
        controller: ['$scope', '$element', '$window', '$timeout', 'authService', SiteHeaderController],
        templateUrl: '/assets/built/app/components/siteHeader/siteHeader.html'
    })
    .component('siteMobileHeader', {
        transclude: true,
        bindings: {
            navItems: '<'
        },
        controller: ['$rootScope', '$scope', 'authService', SiteMobileHeaderController],
        templateUrl: '/assets/built/app/components/siteHeader/siteMobileHeader.html'
    })
    .component('siteDesktopHeader', {
        transclude: true,
        bindings: {
            navItems: '<'
        },
        controller: ['$rootScope', '$scope', 'authService', SiteDesktopHeaderController],
        templateUrl: '/assets/built/app/components/siteHeader/siteDesktopHeader.html'
    });
